import { GraduationCap } from 'lucide-react';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  icon?: React.ReactNode;
  showRefreshButton?: boolean;
}

export const ErrorState = ({
  title = 'Failed to Load Data',
  message = 'There was an error loading the data. Please try refreshing the page or try again later.',
  onRetry,
  icon = <GraduationCap className="h-8 w-8 text-[#0D373D]" />,
  showRefreshButton = true,
}: ErrorStateProps) => {
  return (
    <div className="min-h-screen bg-[#F5F8F9] flex flex-col items-center justify-center gap-6">
      <div className="bg-white p-8 rounded-lg shadow-sm max-w-md w-full text-center border border-gray-100">
        <div className="mb-6">
          <div className="bg-[#E6F4F1] rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
            {icon}
          </div>
          <h3 className="text-[#0D373D] text-xl font-semibold mb-2">{title}</h3>
          <p className="text-gray-600 text-sm">{message}</p>
        </div>
        <div className="flex gap-3 justify-center">
          {onRetry && (
            <button
              onClick={onRetry}
              className="px-6 py-2.5 bg-[#0D373D] text-white rounded-md hover:bg-[#0A2C31] transition-colors duration-200 flex items-center justify-center gap-2 text-sm font-medium"
            >
              Try Again
            </button>
          )}
          {showRefreshButton && (
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2.5 bg-[#E6F4F1] text-[#0D373D] rounded-md hover:bg-[#D1E9E6] transition-colors duration-200 flex items-center justify-center gap-2 text-sm font-medium"
            >
              Refresh Page
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
